import {
  ChakraCollapse,
  ChakraFlex,
  FAIconName,
  Icon,
  Text,
} from '@equip.health/ui';
import { PropsWithChildren, useState } from 'react';

type Props = {
  title: string;
};
export const PatientReadonlyNoteCollapse = ({
  title,
  children,
}: PropsWithChildren<Props>) => {
  const [isExpanded, setIsExpanded] = useState(true);
  return (
    <>
      <ChakraFlex
        alignItems="center"
        flexDirection="row"
        gap="6px"
        onClick={() => setIsExpanded(!isExpanded)}
        paddingY="12px"
      >
        <Icon
          aria-label={isExpanded ? `Collapse ${title}` : `Expand ${title}`}
          color="rgba(0, 0, 0, 0.45)"
          name={
            isExpanded
              ? FAIconName.chevronDownRegular
              : FAIconName.chevronRightRegular
          }
          size="sm"
        />
        <ChakraFlex flexDirection="row" gap="6px">
          <Text color="neutral.primary" variant="h5">
            {title}
          </Text>
        </ChakraFlex>
      </ChakraFlex>
      <ChakraCollapse in={isExpanded}>{children}</ChakraCollapse>
    </>
  );
};
